module.exports = __webpack_public_path__ + "static/media/my_assets_stable_no.2824ba98.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/my_assets_stable_no.png
// module id = 752
// module chunks = 0 1